import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import { blue, Logo } from './styles'
import { logAnalytics, phoneClick } from '../firebase_init';

export default function Footer() {
    return (
        <footer>
            <Box sx={{ width: '100%', bgcolor: blue, borderTopLeftRadius: '15px', borderTopRightRadius: '15px', color: 'white', minHeight: '360px' }}>
                <Container maxWidth='xl' sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', alignContent: 'center', justifyContent: 'center', py: '60px' }}>
                    <Logo sx={{ p: '12px' }} />
                    <Box sx={{ my: '40px', bgcolor: 'white', height: '1px', width: '100%' }}></Box>
                    <Typography sx={{ color: 'white', fontWeight: 400 }}>2026 Profaktura s.r.o | Högrova 2862/2 | Královo Pole | 612 00 Brno | IČO: 21594830 </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '30px', width: 'fit-content', py: '30px' }}>
                        <Box component={'a'} href='tel:+420797996873' sx={{ textDecoration: 'none' }} onClick={() => {
                            logAnalytics("phone_click_fire");
                            phoneClick();
                        }}>
                            <Typography sx={{ color: 'white', fontWeight: 700 }}>Volejte: 797996873</Typography>
                        </Box>
                        <Box component={'a'} href='cookies' sx={{ textDecoration: 'none' }}>
                            <Typography sx={{ color: 'white', fontWeight: 700 }}>Zásady cookies</Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </footer>
    )
}
